import type { IconData } from '@stacksjs/iconify-core'

export const circleClock: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M45 24c0 11.598-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3s21 9.402 21 21\"/><path fill=\"#fff\" d=\"M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24S15.716 9 24 9s15 6.716 15 15\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M9 24a15 15 0 1 0 30 0a15 15 0 1 0-30 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 15v9l6 6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleClock
